import get from 'lodash.get';

const getStaticPrefix = (rootState) => get(rootState, 'config.myyola.static_prefix', '');

export default getStaticPrefix;
